export default {
  'Add Cut': 'Knip toevoegen',
}